'use client';

import { useRouter } from 'next/navigation';

import { routes } from '../data/routes';
import { useCurrentLocale } from '../utils/client';

export function useQuerySearchParam() {
  const router = useRouter();
  const locale = useCurrentLocale();

  function updateQuerySearchParam(
    query: string,
    attributionToken?: string | null,
    selectedSuggestion?: number
  ) {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('query', query);

    if (attributionToken) {
      urlSearchParams.set('at', attributionToken);
    }

    if (selectedSuggestion) {
      urlSearchParams.set('sp', String(selectedSuggestion));
    }

    router.push(`${routes[locale].SEARCH}?${urlSearchParams.toString()}`);
  }

  return { updateQuery: updateQuerySearchParam };
}
